import { Col, Modal, Row, Spin } from 'antd';
import React, { useEffect, useState } from 'react';

import styles from './styles.module.css';
import OnboardHitch from './OnboardHitch';
import useHitchConfiguration from 'components/public/integrations/useHitchConfiguration';
import { useRouter } from 'next/router';
import { createTitleFromHitchId } from 'components/SubscribeForm/utils';
import { BaseUseCase } from 'services/apps/usecases';
import IntroBlock from 'components/public/Intro/IntroBlock';

type OnboardingFlowProps = {
  usecases: BaseUseCase[];
  hitchId: string;
};

const OnboardingFlow = ({ usecases, hitchId }: OnboardingFlowProps): JSX.Element => {
  const hitchConfigurationHook = useHitchConfiguration(hitchId, usecases);
  const { activeHike, loading, hitchGoLive } = hitchConfigurationHook;
  const [activeModal, setActiveModal] = useState<boolean>(false);

  const { replace } = useRouter();

  useEffect(() => {
    if (hitchConfigurationHook.useCaseConfiguration.errorMessage) {
      if (!activeModal) {
        setActiveModal(true);
        Modal.error({
          title: hitchConfigurationHook.useCaseConfiguration.errorMessage,
          content: (
            <>
              <p>{'Something went wrong.'}</p>
              <p>{'Sorry.'}</p>
              <p>{'Contact support, we are glad to help you with this issue.'}</p>
            </>
          ),
          onOk: () => {
            setActiveModal(false);
            hitchConfigurationHook.useCaseConfiguration.setErrorMessage();
            replace('/contact');
          },
        });
      }
    }
  }, [hitchConfigurationHook.useCaseConfiguration, replace, activeModal]);
  useEffect(() => {
    if (hitchGoLive.isLive && activeHike && !activeModal) {
      setActiveModal(true);
      replace(`/dashboard/hike/${activeHike.id}?state=hello`);
    } else if (activeHike && !activeModal && !hitchGoLive.goLiveBusy) {
      setActiveModal(true);
      replace(`/dashboard/hike/${activeHike.id}`);
      Modal.info({
        content: (
          <>
            <h3>
              {`You already have a running integration with both ${createTitleFromHitchId(
                hitchId
              )}`}
            </h3>
            <p>Found out more details on your dashboard</p>
          </>
        ),
      });
    }
  }, [hitchGoLive.isLive, activeHike, replace, activeModal, hitchId, hitchGoLive.goLiveBusy]);

  return (
    <IntroBlock
      type="white"
      description={
        <Col span={24} flex="auto">
          <Spin spinning={hitchGoLive.goLiveBusy || loading}>
            <Row align="stretch" className={styles.onboarding}>
              <OnboardHitch hitchConfigurationHook={hitchConfigurationHook} />
            </Row>
          </Spin>
        </Col>
      }
    />
  );
};
export default OnboardingFlow;
